import type { Menu, Permission } from '@/stores/interface/securityStore.d'

import http from './common/axiosService'

/**
 * Sidebar navigation loaded from the database for the app identified by system_config APP_UID.
 */
export const getMenus = (): Promise<Menu[]> => {
  return http.get<Menu[]>('menu/navigation')
}

/**
 * Get permissions list (reserved for future RBAC beyond menu_role).
 */
export const getPermissions = (): Promise<Permission[]> => {
  return Promise.resolve([])
}
